// reducers/connect/feedback.js

export function connectFeedbackHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_FEEDBACK_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectFeedbackIsLoading(state = false, action) {
  switch (action.type) {
    case 'CONNECT_FEEDBACK_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectFeedback(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_FEEDBACK_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}